import type { DocumentComment } from "./types";

function isDocumentComment(value: unknown): value is DocumentComment {
  if (value == null || typeof value !== "object") return false;
  return typeof (value as DocumentComment).comment_id === "string";
}

/** Normalizes list API payloads and guards against non-array cache values after mutations. */
export function parseDocumentCommentsListResponse(raw: unknown): DocumentComment[] {
  if (Array.isArray(raw)) {
    return raw;
  }

  if (raw != null && typeof raw === "object") {
    const record = raw as Record<string, unknown>;
    if (Array.isArray(record.data)) {
      return record.data as DocumentComment[];
    }
    if (isDocumentComment(raw)) {
      return [raw];
    }
  }

  return [];
}
